export class ShoppingCartRequest {
  idKit: number;
  quantity: number;  
}